import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '@store/app/app.state';

export const selectAppState = createFeatureSelector<AppState>('appState');

export const selectError =                createSelector(selectAppState, (state: AppState) => state.error);
export const selectReturnHome =           createSelector(selectAppState, (state: AppState) => state.returnHome);
export const selectLoginInProcess =       createSelector(selectAppState, (state: AppState) => state.loginInProcess);
export const selectVerifyTotpInProcess =  createSelector(selectAppState, (state: AppState) => state.verifyTotpInProcess);
export const selectShowClientsRequests =  createSelector(selectAppState, (state: AppState) => state.showClientsRequests);